import { Button, Col, Row, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BurgerMenuIcon from "../../../assets/icons/burger-menu.svg";
import LocationIcon from "../../../assets/icons/location.svg";
import VerifyIcon from "../../../assets/icons/verify.svg";
import AvatarComponent from "../../../components/AvatarComponent";
import PresentationVideoButton from "../../../components/discover/common/PresentationVideoButton";
import ShareModalComponent from "../../../components/ShareModalComponent";
import { IUserInfos, IUserSettings } from "../../../helpers/types";
import { getNumberLengthClass } from "../../../helpers/numberClassHelper";
import { StoreState } from "../../../redux/store";
import { formatSpaceNumber } from "../../../utls/FunctionsUtil";

export interface UserInfoComponentProps {
  userPorps: IUserInfos;
  userSettings: IUserSettings | null;
  isShareModalOpen: boolean;
  setIsShareModalOpen: (open: boolean) => void;
}

const UserInfoComponent = ({ userPorps, userSettings, isShareModalOpen, setIsShareModalOpen }: UserInfoComponentProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state: StoreState) => state.users.currentUserProfile) || userPorps;

  const goToSettings = () => {
    navigate("/common/setting");
  };

  const goToPresentationVideo = () => {
    navigate("/creator/create/presentation/videos");
  };

  return (
    <>
      <Row className="header-container">
        <Typography.Text className="header-my-profile-text">@{user.username}</Typography.Text>
        <div className="settings-icon-container" onClick={goToSettings}>
          <img src={BurgerMenuIcon} width={20} alt="settings" />
        </div>
      </Row>

      <div className="fanProfileTopWrapper">
        <Row align="middle">
          <Col className="colAvatar mr-5">
            <AvatarComponent image={user?.avatar || ""} size={125} fontSize={16} fontWeight={true} />
          </Col>
          <Col className="colDetails">
            <Row className="nameRow" align="middle">
              <Row className="ml-20 mt-10 max-w-80 justify-content-between" align="middle">
                <Space>
                  <Col className="colValues">
                    <Row className="fanProfileAttributeRow">
                      <Typography.Text className={`fanProfileAttributeValue ${getNumberLengthClass(user?.stats?.totalFeeds || 0)}`}>
                        {user?.stats?.totalFeeds || 0}
                      </Typography.Text>
                    </Row>
                    <Row className="fanProfileAttributeRow">
                      <Typography.Text className="fanProfileAttributeTitle">{t("publications")}</Typography.Text>
                    </Row>
                  </Col>
                  <Col
                    className="colValues cursor-pointer"
                    onClick={() => {
                      navigate("/creator/allSubscribers");
                    }}
                  >
                    <Row className="fanProfileAttributeRow">
                      <Typography.Text className={`fanProfileAttributeValue ${getNumberLengthClass(user?.stats?.subscribers || 0)}`}>
                        {formatSpaceNumber(user?.stats?.subscribers || 0)}
                      </Typography.Text>
                    </Row>
                    <Row className="fanProfileAttributeRow">
                      <Typography.Text className="fanProfileAttributeTitle">{t("subscribers")}</Typography.Text>
                    </Row>
                  </Col>
                  <Col className="colValues">
                    <Row className="fanProfileAttributeRow">
                      <Typography.Text className={`fanProfileAttributeValue ${getNumberLengthClass(user?.stats?.followers || 0)}`}>
                        {formatSpaceNumber(user?.stats?.followers || 0)}
                      </Typography.Text>
                    </Row>
                    <Row className="fanProfileAttributeRow">
                      <Typography.Text className="fanProfileAttributeTitle">{t("interested")}</Typography.Text>
                    </Row>
                  </Col>
                </Space>
              </Row>
            </Row>

            <Row className="buttonRow mt-20" align="middle">
              <Space>
                <Col>
                  <Button className="editProfileBtn" onClick={() => navigate("/creator/editProfile")}>
                    {t("To-modify")}
                  </Button>
                </Col>
                <Col>
                  <Button className="editProfileBtn" onClick={() => setIsShareModalOpen(true)}>
                    {t("share-profile")}
                  </Button>
                  {/* <img src={NewShareIcon} className="share-icon" alt="share" onClick={() => setIsShareModalOpen(true)} /> */}
                </Col>
              </Space>
            </Row>
          </Col>
        </Row>
      </div>
      <div className="labelWrapper">
        <Typography.Text className="nameTitle">{user?.name}</Typography.Text>
        {user?.verifiedAccount && <img className="verifyIcon" src={VerifyIcon} width={14} alt="verify" />}
        {userSettings?.hasDiscovers && (
          <PresentationVideoButton
            onClick={goToPresentationVideo}
            notificationVisible={userSettings?.expiredDiscovers || userSettings?.rejectedDiscovers || false}
          />
        )}
        {user?.city && (
          <Row className="">
            <Col className="colValues location mt-5">
              <img className="locationImg mr-5" src={LocationIcon} width={16} alt="location" />
              <Typography.Text className="fanProfileLocationLabel">{user.city}</Typography.Text>
            </Col>
          </Row>
        )}
        <Row className="mt-10">
          <div
            className="fanProfileDescriptionLabel"
            dangerouslySetInnerHTML={{
              __html: (user?.description || "").replace(/\n/g, "<br />"),
            }}
          />
        </Row>
      </div>
      <ShareModalComponent isOpen={isShareModalOpen} onClose={() => setIsShareModalOpen(false)} id={user?._id} username={user?.username} />
    </>
  );
};

export default UserInfoComponent;
